import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { ROUTER_NAVIGATION, getRouterSelectors } from '@ngrx/router-store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { GlobalState } from '@/models/auction-house/state';

import { Observable, filter, map, of, switchMap, tap, withLatestFrom } from 'rxjs';

import { AuctionDataService } from '@/services/auction-house/data.service';

import { selectCurrentBlock } from '@/store/auction-house/data.selectors';
import { setActiveAuction } from './data.actions';
import { environment } from 'src/environments/environment';
import { initialState } from './data.reducers';

@Injectable()
export class DataStateEffects {

  routerNavigation$ = createEffect(() => this.actions$.pipe(
    ofType(ROUTER_NAVIGATION),
    switchMap(() => {
      return this.store.select(selectCurrentBlock).pipe(
        filter((currentBlock) => !!currentBlock),
        withLatestFrom(this.store.select(getRouterSelectors().selectRouteParam('auctionId'))),
        switchMap(([currentBlock, auctionId]) => {
          return this.dataSvc.fetchAuction(currentBlock, auctionId);
        }),
        map((data) => setActiveAuction({ activeAuction: data })),
      )
    }),
  ));

  // onBlockNumber$ = createEffect(() => this.actions$.pipe(
  //   ofType(setCurrentBlock),
  //   withLatestFrom(this.store.select(getRouterSelectors().selectRouteParam('auctionId'))),
  //   switchMap(([action, auctionId]) => {
  //     return this.dataSvc.getAuctionFromTokenId(Number(auctionId));
  //   }),
  //   map((data) => setActiveAuction({ activeAuction: data })),
  // ));

  constructor(
    private store: Store<GlobalState>,
    private actions$: Actions,
    private dataSvc: AuctionDataService
  ) {}
}
